import React from 'react';

export type SettingsGlyphName = 'chat';

export type SettingsGlyphProps = {
  name: SettingsGlyphName;
  size?: number;
  /** The stroke (and dot fill) paint: a colour or an SVG paint reference such as a gradient's `url(#…)`. */
  color?: string;
  className?: string;
};

/**
 * The Settings index's own tile glyphs, drawn like the shared `Icon`'s stroke set (24 viewBox, 1.6 stroke, round caps
 * and joins) so they sit beside its glyphs as one family: a chat (a speech bubble with three dots, someone speaking).
 */
export const SettingsGlyph = ({
  name,
  size = 24,
  color = 'currentColor',
  className,
}: SettingsGlyphProps): React.ReactElement => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {name === 'chat' ? (
      <>
        <path d="M6.5 4.5h11a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-6l-4 3.3v-3.3h-1a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3Z" />
        <circle cx="8" cy="10.5" r="1" fill={color} stroke="none" />
        <circle cx="12" cy="10.5" r="1" fill={color} stroke="none" />
        <circle cx="16" cy="10.5" r="1" fill={color} stroke="none" />
      </>
    ) : null}
  </svg>
);

export default SettingsGlyph;
